import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
//import Loader from 'src/components/system_wide/loader'
import RiApp from './ri_app'
import LoginPage from 'src/pages/login'
import DashboardPage from 'src/pages/dashboard'
import ManageUsersPage from 'src/pages/users'
import ManageBrandsPage from 'src/pages/brand'
import ManageCategoriesPage from 'src/pages/category'
import MessagesPage from 'src/pages/messages'
import CalendarPage from 'src/pages/calendar'
import ManageDocumentsPage from 'src/pages/documents'
import AppointmentsPage from 'src/pages/appointment'
import ErrorPage from './error-page'
import ContractsPage from 'src/pages/contracts'
import MetadataPage from 'src/pages/metadata'
import MapPage from 'src/pages/map'
import MapDealersPage from 'src/pages/map_dealers'
import ManageDealersPage from 'src/pages/dealers'

export default function RiRouter() {
  return (
    <Routes>
      <Route element={<RiApp />}>
        <Route path="/" element={<Navigate to="dashboard" />} />
        <Route path="/messages" element={<MessagesPage />} />
        <Route path="/documents" element={<ManageDocumentsPage />} />
        <Route path="/calendar" element={<CalendarPage />} />
        <Route path="/appointments" element={<AppointmentsPage />} />
        <Route path="/contracts" element={<ContractsPage />} />
        <Route path="/metadata" element={<MetadataPage />} />
        <Route path="/users" element={<ManageUsersPage />} />
        <Route path="/brands" element={<ManageBrandsPage />} />
        <Route path="/dealers" element={<ManageDealersPage />} />
        <Route path="/categories" element={<ManageCategoriesPage />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/map" element={<MapPage />} />
        <Route path="/map_dealers" element={<MapDealersPage />} />
        <Route path="/login" element={<LoginPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/404" replace />} />
      <Route path="/404" element={<ErrorPage />} />
    </Routes>
  )
}
